import { postRequest } from "./api";
import { API_URL } from "./Environment";

export const getCustomerInfo = async (payload) => {
  return postRequest(`${API_URL}chat/get-customer`, payload).then(
    (resp) => resp,
  );
};

export const getFaqRelatedAnswer = async (payload, shopId) => {
  return postRequest(
    `${API_URL}chat/get-query-match-answer?shopId=${shopId}`,
    payload,
  ).then((resp) => resp);
};
